export const SET_KEY = "set_key";
export const SET_USERS = "set_users";
export const SET_MODE = "set_mode";